<template>
    <div class="d-flex align-items-stretch">
        <parens left />
        <div
            v-bind:class="{ 'flex-column': wrap }"
            class="d-flex align-items-center">
            <div class="d-flex align-items-center">
                <div v-bind:class="textOperatorClassName">IF</div>
                <component
                    v-bind:is="formulaControl.childExpressionComponent"
                    v-bind:child-binder="ifEx" />
            </div>

            <div class="d-flex align-items-center">
                <div v-bind:class="textOperatorClassName">THEN</div>
                <component
                    v-bind:is="formulaControl.childExpressionComponent"
                    v-bind:child-binder="thenEx" />
            </div>

            <div class="d-flex align-items-center">
                <div v-bind:class="textOperatorClassName">ELSE</div>
                <component
                    v-bind:is="formulaControl.childExpressionComponent"
                    v-bind:child-binder="elseEx" />
            </div>
        </div>
        <parens />
    </div>
</template>
<script>
    import base from "./_baseExpression.vue";

    export default {
        extends: base,
        computed: {
            ifEx() {
                return this.getChildBinderByIndex(0);
            },
            thenEx() {
                return this.getChildBinderByIndex(1);
            },
            elseEx() {
                return this.getChildBinderByIndex(2);
            }
        }
    };
</script>
